var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDnsPrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-DNS-private",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(-1294.709 -48.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606",
    transform: "translate(-2.861 -2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M0,0A6.867,6.867,0,0,0,2.125,3.769c2.182,2.254,2.758,2.014,8,1.746,5.672-.292,13.6,3.054,14.4,4.872H.016S-.009.084,0,0Z",
    transform: "translate(1332.57 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M0,0S.142,1.127,2.125,2.469c2.182,1.477,2.758,1.319,8,1.144,5.672-.191,13.6,2,14.4,3.192H.016S-.009.055,0,0Z",
    transform: "translate(1327.376 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.064
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12412",
    "data-name": "Path 12412",
    d: "M1222.758,15.6h-6.264c-.206,0-.373-.352-.373-.786s.167-.786.373-.786h6.264c.206,0,.373.352.373.786S1222.964,15.6,1222.758,15.6Z",
    transform: "translate(136.463 54.11)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12314",
    "data-name": "Path 12314",
    d: "M1224.011,15.6h-7.446c-.245,0-.444-.352-.444-.786s.2-.786.444-.786h7.446c.245,0,.444.352.444.786S1224.256,15.6,1224.011,15.6Z",
    transform: "translate(89.481 82.58)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12411",
    "data-name": "Path 12411",
    d: "M1232.973,19.581h-6.9c-.206,0-.373-.352-.373-.787s.167-.785.373-.785h6.9c.206,0,.373.352.373.785S1233.179,19.581,1232.973,19.581Z",
    transform: "translate(131.745 53.371)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12315",
    "data-name": "Path 12315",
    d: "M1234.346,19.581h-8.2c-.245,0-.444-.352-.444-.787s.2-.785.444-.785h8.2c.245,0,.444.352.444.785S1234.591,19.581,1234.346,19.581Z",
    transform: "translate(85.682 81.84)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pc",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17129",
    "data-name": "Rectangle 17129",
    width: 36,
    height: 24,
    rx: 1,
    transform: "translate(1320.709 72.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    x2: 20,
    transform: "translate(1328.709 104.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    y2: 8,
    transform: "translate(1332.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1095",
    "data-name": "Line 1095",
    y2: 8,
    transform: "translate(1344.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17002",
    "data-name": "Group 17002",
    transform: "translate(-4291.232 -1761.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12889",
    "data-name": "Path 12889",
    d: "M4324.717,1794.432a7.819,7.819,0,0,1,15.521-.008h2.522v1.847h-20.568v-1.839Zm13.605-.018a5.917,5.917,0,0,0-11.69,0Z",
    transform: "translate(0 1)",
    fill: "#347cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12890",
    "data-name": "Path 12890",
    d: "M4364.29,1971.863a3.424,3.424,0,0,1,6.646-1.159.314.314,0,0,0,.359.246c.527-.015,1.054-.017,1.581,0a.345.345,0,0,0,.4-.272,3.421,3.421,0,1,1,.013,2.416.384.384,0,0,0-.441-.3c-.517.016-1.035.013-1.552,0a.318.318,0,0,0-.361.243,3.418,3.418,0,0,1-6.586-.594C4364.311,1972.254,4364.308,1972.057,4364.29,1971.863Zm1.87-.007a1.568,1.568,0,1,0,1.6-1.557A1.564,1.564,0,0,0,4366.16,1971.855Zm11.882.031a1.568,1.568,0,1,0-1.579,1.547A1.573,1.573,0,0,0,4378.042,1971.886Z",
    transform: "translate(-39.626 -170.255)",
    fill: "#00aafc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDnsPrivate);
export default __webpack_public_path__ + "static/media/icn-DNS-private.c33889e1ca054f59df08b5028c463cb2.svg";
export { ForwardRef as ReactComponent };